import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: PsfPromoteOrSharePageFcmExperimentsContext,
	FcmExperimentsProvider: PsfPromoteOrSharePageFcmExperimentsContextProvider,
	useFcmExperiments: usePsfPromoteOrSharePageFcmExperiments,
	useAsyncFcmExperiments: useAsyncPsfPromoteOrSharePageFcmExperiments,
	prefetchFcmExperiments: prefetchPsfPromoteOrSharePageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'PsfPromoteOrSharePageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {},
	prefetch: true,
});

export type PsfPromoteOrSharePageFcmExperimentsState = ReturnType<typeof useAsyncPsfPromoteOrSharePageFcmExperiments>;
export type PsfPromoteOrSharePageFcmExperiments = LoadedStateData<PsfPromoteOrSharePageFcmExperimentsState>;
